export const warehousing = undefined //  入仓的omsType， 数据一般为0 ， 这里调整为undefined 是因为需求开发过程中 突发变更，因此这里做了兜底处理
